import PropTypes from "prop-types";
import React from "react";
import {
    Button,
    Form,
    Grid,
    Icon,
    Segment,
    Table,
} from "semantic-ui-react";
import Deadline from "./util/Deadline";
import debounce from "./util/debounce";
import DescriptionParser from "./util/DescriptionParser";
import Markdown from "./util/Markdown";
import Media from "./util/Media";
import STATUS from "./util/STATUS";

class ContextEditor extends React.PureComponent {

    constructor(props) {
        super(props);
        const c = props.context;
        this.state = {
            title: c.title,
            status: c.status,
            description: c.description,
            parts: new DescriptionParser(c.description),
            image: null, // write only!
            allowSubmit: true,
        };
        this.handleChange = this.handleChange.bind(this);
        this.reparseDescription = debounce(() => {
            this.setState({
                parts: new DescriptionParser(this.state.description),
                allowSubmit: true,
            });
        }, 750);
    }

    handleChange(e, d) {
        const delta = {
            [d.name]: e.target.value,
        };
        if (d.name === "description") {
            this.reparseDescription();
            delta.allowSubmit = false;
        }
        this.setState(delta);
    }

    render() {
        const {
            doSave,
            doCancel,
        } = this.props;
        const {
            title,
            status,
            description,
            parts,
            image,
            allowSubmit,
        } = this.state;
        return <Grid columns={2} stackable divided>
            <Grid.Column>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Input label="Title"
                                    name="title"
                                    value={title}
                                    onChange={this.handleChange}
                        />
                        <Form.Select label="Status"
                                     name="status"
                                     value={status}
                                     options={
                                         Object.keys(STATUS)
                                             .map(k => STATUS[k])
                                             .map(l => ({
                                                 text: l,
                                                 value: l,
                                             }))
                                     }
                                     onChange={(e, d) =>
                                        this.setState({ status: d.value })}
                        />
                    </Form.Group>
                    <Form.TextArea label="Description"
                                   name="description"
                                   value={description}
                                   rows={12}
                                   onChange={this.handleChange}
                    />
                    <Form.Field label="Image"
                                control={Media}
                                value={image}
                                onChange={v => this.setState({ image: v })}
                    />
                    <Form.Field control={Button.Group}>
                        <Button primary
                                disabled={!allowSubmit}
                                onClick={() => doSave({
                                    title,
                                    status,
                                    description,
                                    parsedDescription: parts.stripped,
                                    regions: parts.regions,
                                    image,
                                })}
                        >
                            <Icon name="save" />
                            Save
                        </Button>
                        <Button secondary
                                onClick={() => doCancel()}
                        >
                            Cancel
                        </Button>
                    </Form.Field>
                </Form>
            </Grid.Column>
            <Grid.Column>
                <h2>{title}</h2>
                <Markdown text={parts.stripped || ""} />
                <Segment basic>
                    <Table compact unstackable striped>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Type</Table.HeaderCell>
                                <Table.HeaderCell>When</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {parts.regions && parts.regions.length > 0 && parts.regions.map(r =>
                                <Table.Row key={r.name}>
                                    <Table.Cell>{r.name}</Table.Cell>
                                    <Table.Cell>
                                        {r.accept && r.accept.join(", ")}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {r.when && <Deadline ts={r.when} />}
                                    </Table.Cell>
                                </Table.Row>,
                            )}
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan={3}>
                                    <code>{`"!" ? "{{" region [ "|" date_string ] "|" { "file" | "notes" | "counters" } "}}"`}</code>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                </Segment>
            </Grid.Column>
        </Grid>;
    }
}

ContextEditor.propTypes = {
    context: PropTypes.object.isRequired,
    doSave: PropTypes.func.isRequired,
    doCancel: PropTypes.func.isRequired,
};

export default ContextEditor;



// WEBPACK FOOTER //
// ./src/ContextEditor.js